export default function BottomCall() {
  return (
   <div className="bottom-call-btn">
        <div className="bottom-call-tooltip">
            <i className="fas fa-headset"></i>
            <span>Talk to Expert: 8863093448</span>
        </div>
        <a href="tel:8863093448" className="bottom-call-button">
            <i className="fas fa-phone"></i>
        </a>
    </div>
  );
}